import * as React from "react";

function SvgXplenty(props, ref) {
  return (
    <svg
      id="Xplenty_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="-73 98 106.7 63"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Xplenty_svg__st0{fill:#3f3f3f}"}</style>
      <path
        className="Xplenty_svg__st0"
        d="M-31.9 98c-14.8 0-26.9 12.1-26.9 26.9 0 4.2 1 8.2 2.7 11.8h2.4c-1.9-3.5-3-7.5-3-11.8 0-13.7 11.1-24.8 24.8-24.8 13.7 0 24.8 11.1 24.8 24.8 0 4.3-1.1 8.3-3 11.8h2.4c1.8-3.6 2.7-7.6 2.7-11.8C-5 110.1-17 98-31.9 98z"
      />
      <path
        d="M-43.7 123.2l5.2 4.4 7.3-12 9.1 14.7 4.9-4 5.7 8.2c1.4-2.9 2.1-6.1 2.1-9.6 0-12.4-10.1-22.5-22.5-22.5s-22.5 10.1-22.5 22.5c0 3.8 1 7.4 2.6 10.5l8.1-12.2z"
        fill="#0ab3e5"
      />
      <path
        className="Xplenty_svg__st0"
        d="M-64.7 146.1l5.7 7.9h-2.6l-4.3-6.3-4.4 6.3H-73l5.7-7.9-5.4-7.6h2.7l4.1 5.9 4.1-5.9h2.6l-5.5 7.6zM-52.4 140.7c1.1-1.6 2.7-2.4 4.8-2.4s3.7.7 4.8 2.1c1.1 1.4 1.7 3.4 1.7 5.9s-.6 4.5-1.7 5.9-2.7 2.1-4.8 2.1-3.7-.8-4.8-2.3h-.2c.1.9.2 1.8.2 2.6v6.4h-2.4v-22.5h1.9l.3 2.1.2.1zm0 5.6c0 2.2.4 3.7 1.1 4.7.7.9 1.9 1.4 3.5 1.4 1.4 0 2.4-.5 3.2-1.6.8-1.1 1.1-2.6 1.1-4.5s-.4-3.4-1.1-4.4c-.8-1-1.8-1.6-3.2-1.6-1.6 0-2.7.4-3.5 1.3-.7.9-1.1 2.3-1.1 4.2v.5zM-33.5 154.1h-2.4V132h2.4v22.1zM-21.4 154.3c-2.3 0-4.1-.7-5.4-2.1s-2-3.4-2-5.8.6-4.5 1.8-5.9c1.2-1.5 2.9-2.2 4.9-2.2s3.6.6 4.7 1.9 1.7 2.9 1.7 5v1.5h-10.6c0 1.8.5 3.2 1.4 4.1s2.1 1.4 3.8 1.4 3.3-.3 4.9-1v2.1c-.8.4-1.6.6-2.4.8-.8.2-1.7.2-2.8.2zm3.2-9.5c0-1.5-.3-2.6-1-3.4s-1.6-1.2-2.8-1.2c-1.2 0-2.2.4-3 1.2-.7.8-1.2 1.9-1.3 3.4h8.1zM-3.1 138.3c1.9 0 3.3.5 4.2 1.4.9.9 1.4 2.4 1.4 4.3v10.1H.1V144c0-1.3-.3-2.2-.9-2.8-.6-.6-1.5-.9-2.7-.9-1.6 0-2.8.4-3.6 1.3s-1.1 2.3-1.1 4.3v8.1h-2.3v-15.5h1.9l.4 2.1h.1c.5-.8 1.2-1.4 2-1.8.9-.3 1.9-.5 3-.5zM11 138.5h4.5v1.8H11v9.1c0 .9.2 1.6.7 2.1.4.5 1 .8 1.8.8s1.5-.1 2.2-.3v1.8c-.2.1-.6.2-1.1.3-.5.1-1 .1-1.4.1-3 0-4.5-1.6-4.5-4.7v-9.2H6.4v-1.1l2.2-1 1-3.3H11v3.6zM21.5 161c-.7 0-1.4-.1-2.1-.2v-1.9c.5.1 1.1.2 1.7.2 1.6 0 2.8-.9 3.5-2.7l.9-2.2-6.3-15.6h2.5l3.4 8.8c.7 2 1.2 3.4 1.4 4.4h.1c.1-.5.4-1.2.7-2.3.3-1 1.6-4.7 3.9-11h2.5L27 156.2c-.7 1.8-1.5 3-2.3 3.7-.9.8-1.9 1.1-3.2 1.1z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgXplenty);
